import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ListadoProfesiones from './components/ListadoProfesiones';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allProfesionesAction,
  setActivoProfesionesAction,
} from './ProfesionesAction';
import FormProfesiones from './components/FormProfesiones';

const ProfesionesView = () => {
  const dispatch = Redux.useDispatch();

  const profesionesStore = Redux.useSelector((state) => state.profesiones);
  const [isDelete, setIsDelete] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoProfesionesAction(dispatch, null);
            await allProfesionesAction(dispatch, profesionesStore.params);
          }}
          disabled={
            profesionesStore.loadingAll || profesionesStore.all.length === 0
          }
          white
          refreshIcon
          text={profesionesStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={4}>
        <Paper elevation={5} sx={{ pb: 1 }}>
          <FormProfesiones isDelete={isDelete} />
        </Paper>
      </Grid>
      <Grid item md={8}>
        <ListadoProfesiones
          isDelete={isDelete}
          setIsDelete={(v) => setIsDelete(v)}
        />
      </Grid>
    </Grid>
  );
};

export default ProfesionesView;
